import React from 'react';

export class Table extends React.Component {
    render() {
        let className = 'cc-table';
        if (this.props.striped) {
            className += ' cc-table-striped';
        }
        if (this.props.hover) {
            className += ' cc-table-hover';
        }
        if (this.props.compact) {
            className += ' cc-table-compact';
        }
        if (this.props.topborder) {
            className += ' cc-table-topborder';
        }
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        return (
            <table className={className} style={this.props.style}>
                {this.props.children}
            </table>
        );
    }
}

export class Th extends React.Component {
    constructor(props) {
        super(props);
        this._onClick = this._onClick.bind(this);
    }

    _onClick() {
        if (this.props.onSort) {
            this.props.onSort(this.props.id);
        }
    }

    render() {
        let className = 'cc-text-right';
        if (this.props.left) {
            className = 'cc-text-left';
        } else if (this.props.center) {
            className = 'cc-text-center';
        }
        if (this.props.min === true) {
            className += ' cc-col-min';
        } else if (this.props.min) {
            className += ` cc-col-min-${this.props.min}`;
        }
        if (this.props.ellipsis) {
            className += ` cc-col-ellipsis-${this.props.ellipsis}`;
        }
        if (this.props.priority) {
            className += ` cc-col-priority-${this.props.priority}`;
        }
        if (this.props.show) {
            className += ` cc-col-show-${this.props.show}`;
        }
        let sortable;
        if (this.props.sortable) {
            className += ' cc-sortable-header';
            sortable = <div className="cc-sort-desc" />;
        }
        if (this.props.sort && this.props.sort === this.props.id) {
            className += ' cc-sortable-header-sorted';
        }
        if (this.props.nopadding) {
            className += ' cc-cell-nopadding';
        }
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        let children = this.props.children;
        const props = {};
        if (this.props.short && this.props.value) {
            className += ` cc-col-short-${this.props.short}`;
            props['data-short'] = this.props.value;
            children = <span>{children}</span>;
        }
        return (
            <th className={className} style={this.props.style} onClick={this._onClick} {...props}>
                {children}
                {sortable}
            </th>
        );
    }
}

export class Td extends React.Component {
    render() {
        let className = 'cc-text-right';
        if (this.props.left) {
            className = 'cc-text-left';
        } else if (this.props.center) {
            className = 'cc-text-center';
        }
        if (this.props.min === true) {
            className += ' cc-col-min';
        } else if (this.props.min) {
            className += ` cc-col-min-${this.props.min}`;
        }
        if (this.props.ellipsis) {
            className += ` cc-col-ellipsis-${this.props.ellipsis}`;
        }
        if (this.props.priority) {
            className += ` cc-col-priority-${this.props.priority}`;
        }
        if (this.props.show) {
            className += ` cc-col-show-${this.props.show}`;
        }
        if (this.props.sortable) {
            className += ' cc-sortable-header';
        }
        if (this.props.wrap) {
            className += ' cc-cell-wrap';
        }
        if (this.props.nopadding) {
            className += ' cc-cell-nopadding';
        }
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        let children = this.props.children;
        const props = {};
        if (this.props.short && this.props.value) {
            className += ` cc-col-short-${this.props.short}`;
            props['data-short'] = this.props.value;
            children = <span>{children}</span>;
        }
        if (this.props.colspan) {
            props.colSpan = this.props.colspan;
        }
        return (
            <td className={className} style={this.props.style} {...props} onTouchEnd={this.props.onTouchEnd}>
                {children}
            </td>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Table.jsx